import { useIntl } from 'react-intl';
import { ROUTES } from 'src/constants/routes.const';
import { Query, useHref } from 'src/hooks/useHref';
import * as Types from 'src/types/domain';
import { MediaCard } from '../MediaCard';
import { msgs } from './messages';
import * as S from './styles';

export type ScenarioCardProps = { scenario: Types.ScenarioResponse; scenarioLinkQuery?: Query };

export const ScenarioCard = ({
  scenario: {
    numberOfLearnables,
    scenarioId,
    title,
    titleSlug,
    topic: { iconUrl: topicIconUrl, name: topicName, nameSlug: topicNameSlug, topicId },
    videoUrl,
  },
  scenarioLinkQuery,
}: ScenarioCardProps) => {
  const intl = useIntl();

  const infoNode = (
    <>
      <S.MediaCardTitle title={title}>{title}</S.MediaCardTitle>

      <S.MediaCardDescription>
        <S.Topic>
          <S.TopicIcon alt={topicName} loading="lazy" src={topicIconUrl} />
          {topicName}
        </S.Topic>

        <S.LearnablesCount>
          {intl.formatMessage(msgs.learnablesCount, {
            number: numberOfLearnables,
          })}
        </S.LearnablesCount>
      </S.MediaCardDescription>
    </>
  );

  const linkHref = useHref({
    pathname: ROUTES.scenario,
    query: {
      topicId,
      topicTitleSlug: topicNameSlug,
      scenarioId,
      scenarioTitleSlug: titleSlug,
      ...scenarioLinkQuery,
    },
  });

  const mediaNode = videoUrl ? (
    <S.VideoPlayer
      autoPlay={false}
      playOnKeyboardShortcut={false}
      preload="metadata"
      src={videoUrl}
      title={title}
    />
  ) : (
    <S.NoVideoPlaceholderContainer>
      <S.NoVideoPlaceholder alt={topicName} src={topicIconUrl} />
    </S.NoVideoPlaceholderContainer>
  );

  return (
    <MediaCard
      data-testid="featuredScenarioCard"
      infoNode={infoNode}
      linkHref={linkHref}
      linkLabel={intl.formatMessage(msgs.scenarioDetails)}
      mediaNode={mediaNode}
    />
  );
};
